import { createContext } from 'react';
import { User } from '@typings';

export type UserContextType = {
  user: User;
  setUser: (user: User) => void;
};

export const UserContext = createContext<UserContextType | null>(null);
